import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as UIC from '@dds-uicore/all';
import { CommonService } from 'src/app/shared/services/common.service';
import { DatePipe } from '@angular/common'
import { AuthService } from 'src/app/shared/services/auth.service';
@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {
  currentUrl: any;
  status: any;
  loading: boolean = false;
  rowData: Object = [];
  constructor(private datePipe: DatePipe,private authService:AuthService, private activatedRoute: ActivatedRoute, private router: Router, private commonService: CommonService) { }

  ngOnInit(): void {
    this.authService.setPreviousRoute('grid');
    this.activatedRoute.params.subscribe(params => {
      this.status = params.status;
      this.currentUrl = this.router.url;
      this.loading = true;
      this.commonService.getDashboardTable(this.status).subscribe(
        result => {
          if(result.Status=="Failure"){
            this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
            this.router.navigateByUrl('/home');
            return;
          }
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            this.rowData[i] = {
              data: [
                '<a href=' + data[i].Route.toLowerCase() + '>' + data[i].Title + '</a>',
                this.datePipe.transform(data[i].ScheduledStartDate, 'MM/dd/yyyy'),
                this.datePipe.transform(data[i].ScheduledEndDate, 'MM/dd/yyyy'),
                data[i].CreatedBy
              ]
            }
          }
          var options = {

            search: true,
            select: false,
            actions: false,
            settings: false,
            print: false,
            sort: true,
            expand: false,
            condensed: false,
            fixedColumns: true,
            fixedHeight: true,
            header: true,
            perPage: 10,
            perPageSelect: [10, 20, 40, 80, 100],
            layout: {
              row1: "{search:1:end}{placeholder:1}{actions:1:start}"
            },
            data: {
              headings: ["Title", "Start Date", "End Date", "Publisher"],
              columns: [
                { select: [0, 3], sort: "asc", fixed: true },
                { select: [1, 2], type: "date", format: "MM/DD/YYYY", sortable: true }
              ],
              rows: this.rowData
            }
          };
          [].forEach.call(document.querySelectorAll("[data-table=\"dds__table\"]"),
            function (element) { new UIC.Table(element, options); });


          this.loading = false;
        })
    })


  }

}
